import _Vue from 'vue';
import Api from '@/services/Api';
import Repository from '@/services/Repository';
import AclManagement from '@/services/AclManagement';
import Routing from '@/services/Routing';
import {VueRouter} from 'vue-router/types/router';

declare module 'vue/types/vue' {
    // noinspection JSUnusedGlobalSymbols
    interface Vue {
        $locator: Locator;
    }
}

class Locator {

    public repository: Repository;
    public routing: Routing;
    public api: Api;
    public aclManagement: AclManagement;

    private readonly router: VueRouter;

    constructor(router: VueRouter) {
        this.router = router;
        // @ts-ignore
        this.repository = new _Vue(Repository);
        this.routing = new Routing(this.router);
        this.api = new Api(this.repository);
        this.aclManagement = new AclManagement(this.repository, this.api);
    }
}

export default function LocatorPlugin(Vue: typeof _Vue, options: {router: VueRouter}): void {
    Vue.prototype.$locator = new Locator(options.router);
}